var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgArrowBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 40,
  width: 40
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.667 36.667 0 20 16.667 3.333l2.541 2.584L5.125 20l14.083 14.083Z"
})));

export default SvgArrowBack;